/** @plugin */

import { gettext } from "@nextgisweb/pyramid/i18n";
import { registry } from "@nextgisweb/webmap/panel/registry";
import type { DisplayConfig } from "@nextgisweb/webmap/type/api";

import WifiIcon from "@nextgisweb/icon/material/wifi";

registry.register(COMP_ID, {
    widget: () => import("./TrackersPanel"),
    name: "trackers",
    title: gettext("Trackers"),
    icon: <WifiIcon />,
    order: 80,
    applyToTinyMap: false,

    isEnabled: ({ config }: { config: DisplayConfig }) => {
        const isTrackerPluginEnabled =
            config.webmapPlugin &&
            Object.keys(config.webmapPlugin).includes(
                "@nextgisweb/tracker/plugin"
            );

        return isTrackerPluginEnabled;
    },
});
